import { useChannelContext } from "client/components/channel"
import { useCallback, useEffect, useState } from "react"

import { defaultVideoState } from "./VideoState"

export const useAlreadyPlayed = (
  videoElement: HTMLVideoElement | null,
) => {
  const [alreadyPlayed, setAlreadyPlayed] = useState(
    defaultVideoState.alreadyPlayed,
  )
  const onPlayChange = useCallback(() => {
    if (!alreadyPlayed) {
      setAlreadyPlayed(true)
    }
  }, [alreadyPlayed])

  const { live } = useChannelContext()
  useEffect(() => {
    if (!live) {
      setAlreadyPlayed(false)
    }
  }, [live])

  useEffect(() => {
    videoElement?.addEventListener("play", onPlayChange)
    return () => {
      videoElement?.removeEventListener("play", onPlayChange)
    }
  }, [videoElement])

  return alreadyPlayed
}
